module.exports = __webpack_public_path__ + "static/media/Inter-ExtraLight-BETA.caa9496d.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Inter/Inter-ExtraLight-BETA.woff
// module id = 687
// module chunks = 21